import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import {
    CAROUSEL_DEFAULT_ARGS,
    CAROUSEL_HIGHLIGHTS_ARGS,
    CAROUSEL_LISTING_GALLERY_ARGS
} from '../constants/carousel-args';
import { $mediaStatus } from '../stores/deviceStatus';
import { subscribeKeys } from 'nanostores';

export default class Carousel extends HTMLElement {
    constructor(m) {
        super(m);

        // Binding
        this.onPrefersReducedMotionChange = this.onPrefersReducedMotionChange.bind(this);
        this.onSmallDetectionChange = this.onSmallDetectionChange.bind(this);

        // UI
        this.$swiper = this.querySelector('[data-swiper]');
        this.$parent = this.closest('[data-carousel-parent]');
        this.$prevButton = this.$parent?.querySelector('[data-swiper-prev]');
        this.$nextButton = this.$parent?.querySelector('[data-swiper-next]');

        // Data
        this.swiper = null;
        this.type = this.dataset.type;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.unbindPrefersReducedMotion = subscribeKeys(
            $mediaStatus,
            ['isReducedMotion'],
            this.onPrefersReducedMotionChange
        );

        this.unbindSmallDetection = subscribeKeys(
            $mediaStatus,
            ['isSmall'],
            this.onSmallDetectionChange
        );
    }

    disconnectedCallback() {
        this.destroySwiper();
        this.unbindPrefersReducedMotion?.();
        this.onSmallDetectionChange?.();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onPrefersReducedMotionChange() {
        if (this.type === 'listing-gallery' && !$mediaStatus.get().isSmall) return;
        this.destroySwiper();
        this.initSwiper();
    }

    onSmallDetectionChange() {
        if (
            this.type === 'listing-gallery' &&
            $mediaStatus.get().isSmall &&
            !$mediaStatus.get().isReducedMotion
        ) {
            this.initSwiper();
        } else if (this.type === 'listing-gallery' && !$mediaStatus.get().isSmall) {
            this.destroySwiper();
        }
    }

    // =============================================================================
    // Methods
    // =============================================================================
    initSwiper() {
        let argsFunction;
        let modules;

        switch (this.type) {
            case 'listing-gallery':
                argsFunction = CAROUSEL_LISTING_GALLERY_ARGS;
                break;

            case 'highlights':
                argsFunction = CAROUSEL_HIGHLIGHTS_ARGS;
                modules = [Navigation];
                break;

            default:
                argsFunction = CAROUSEL_DEFAULT_ARGS;
                modules = [Navigation];
                break;
        }

        const args = argsFunction({
            modules,
            $swiper: this,
            $prevButton: this.$prevButton,
            $nextButton: this.$nextButton,
            isPrefersReducedMotion: $mediaStatus.get().isReducedMotion
        });

        this.swiper = new Swiper(this, { init: false, ...args });
        this.swiper.autoplay?.pause();
        this.swiper.init();
    }

    destroySwiper() {
        this.swiper?.destroy(true, true);
    }
}
